import getRequest from '../../../getRequest';

/**
 * Get user type mapping from PRISM db.
 *
 * @returns {Promise}
 */
function getUserTypes() {
  const endpoint = '/users-management/get-user-types/';

  return new Promise((resolve, reject) => {
    getRequest(endpoint, 'Get User Types')
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
}

export default getUserTypes;
